import { MutationOptions } from 'apollo-client';
import {
  DocumentCreateInput,
  DocumentSectionCreateInput,
  DocumentSectionType,
  DocumentSectionUpdateInput,
  DocumentUpdateInput
} from '../../graphql/types';
import {
  MUTATION_CREATE_EMPLOYMENT_DOCUMENT,
  MUTATION_CREATE_EMPLOYMENT_DOCUMENT_SECTION,
  MUTATION_DELETE_EMPLOYMENT_DOCUMENT,
  MUTATION_DELETE_EMPLOYMENT_DOCUMENT_SECTION,
  MUTATION_UPDATE_EMPLOYMENT_DOCUMENT,
  MUTATION_UPDATE_EMPLOYMENT_DOCUMENT_SECTION
} from '../../graphql/mutations/documents';
import { clearCache } from '../../graphql/queriesUtils';

export class DocumentsOnWelcomePage {
  private static refetchQueries = ['queryGetEmploymentDocumentSections'];
  private static updateQueries = ['employmentDocumentSections'];
  private static updateFragments = ['DocumentType', 'DocumentSectionType'];

  public static CreateDocumentSection: MutationOptions<
    {
      result: DocumentSectionType;
    },
    {
      input: DocumentSectionCreateInput;
    }
  > = {
    mutation: MUTATION_CREATE_EMPLOYMENT_DOCUMENT_SECTION,
    refetchQueries: DocumentsOnWelcomePage.refetchQueries,
    update: clearCache(
      DocumentsOnWelcomePage.updateQueries,
      DocumentsOnWelcomePage.updateFragments
    )
  };

  public static UpdateDocumentSection: MutationOptions<
    {
      result: DocumentSectionType;
    },
    {
      input: DocumentSectionUpdateInput;
    }
  > = {
    mutation: MUTATION_UPDATE_EMPLOYMENT_DOCUMENT_SECTION,
    refetchQueries: DocumentsOnWelcomePage.refetchQueries,
    update: clearCache(
      DocumentsOnWelcomePage.updateQueries,
      DocumentsOnWelcomePage.updateFragments
    )
  };

  public static DeleteDocumentSection: MutationOptions<
    {
      result: boolean;
    },
    {
      id: string;
    }
  > = {
    mutation: MUTATION_DELETE_EMPLOYMENT_DOCUMENT_SECTION,
    refetchQueries: DocumentsOnWelcomePage.refetchQueries,
    update: clearCache(
      DocumentsOnWelcomePage.updateQueries,
      DocumentsOnWelcomePage.updateFragments
    )
  };

  public static CreateDocument: MutationOptions<
    {
      result: DocumentType;
    },
    {
      input: DocumentCreateInput;
    }
  > = {
    mutation: MUTATION_CREATE_EMPLOYMENT_DOCUMENT,
    refetchQueries: DocumentsOnWelcomePage.refetchQueries,
    update: clearCache(
      DocumentsOnWelcomePage.updateQueries,
      DocumentsOnWelcomePage.updateFragments
    )
  };

  public static UpdateDocument: MutationOptions<
    {
      result: DocumentType;
    },
    {
      input: DocumentUpdateInput;
    }
  > = {
    mutation: MUTATION_UPDATE_EMPLOYMENT_DOCUMENT,
    refetchQueries: DocumentsOnWelcomePage.refetchQueries,
    update: clearCache(
      DocumentsOnWelcomePage.updateQueries,
      DocumentsOnWelcomePage.updateFragments
    )
  };

  public static DeleteDocument: MutationOptions<
    {
      result: boolean;
    },
    {
      id: string;
    }
  > = {
    mutation: MUTATION_DELETE_EMPLOYMENT_DOCUMENT,
    refetchQueries: DocumentsOnWelcomePage.refetchQueries,
    update: clearCache(
      DocumentsOnWelcomePage.updateQueries,
      DocumentsOnWelcomePage.updateFragments
    )
  };
}
